import gql from 'graphql-tag';

export const ContentHeaderQuery = gql`
	query ContentHeaderQuery($contentId: ID) {
		content(id: $contentId, status: ["archived", "current", "draft"]) {
			nodes {
				id
				title
				type
				metadata {
					lastModifiedDate
				}
				history {
					createdBy {
						displayName
					}
				}
				version {
					by {
						displayName
					}
					when
				}
			}
		}
	}
`;
